import { useSnack } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import {
  getUnofficialEnergyCertificate,
  getUnofficialEnergyCertificateFlerboligbygg,
  getUnofficialEnergyCertificateFlerboligbyggWithPrioritizedMeasures,
  getUnofficialEnergyCertificateWithPrioritizedMeasures
} from '../services/api';
import { queryKeys } from '../utils/react-query';
import { createErrorMessage, downloadFile } from '../utils/utils';
import { EkspertInndata } from '../types/expertToolsJSON';

export const useGetUnofficialEnergyCertificate = (
  registrationId: string | undefined,
  ekspertInndata: EkspertInndata | undefined = undefined
) => {
  const { addSnack } = useSnack();
  const { t } = useTranslation();

  const errorMessage = createErrorMessage(t('downloadError'));

  const { isFetching, refetch } = useQuery(
    [queryKeys.unofficialEnergyCertificate, registrationId],
    () =>
      ekspertInndata
        ? getUnofficialEnergyCertificateWithPrioritizedMeasures(registrationId, ekspertInndata?.tiltaksListe)
        : getUnofficialEnergyCertificate(registrationId),
    {
      onSuccess: ({ data, filename }) => {
        const blobUrl = URL.createObjectURL(data);

        try {
          downloadFile({
            uri: blobUrl,
            filename
          });
        } catch {
          addSnack(errorMessage, { variant: 'error' });
        } finally {
          URL.revokeObjectURL(blobUrl);
        }
      },
      onError: () => {
        addSnack(errorMessage, { variant: 'error' });
      },
      enabled: false
    }
  );

  return { getCertificate: () => refetch(), isLoading: isFetching };
};

export const useGetUnofficialEnergyCertificateFlerbolig = (
  flerboligbyggId: string | undefined,
  ekspertInndata: EkspertInndata | undefined = undefined
) => {
  const { addSnack } = useSnack();
  const { t } = useTranslation();

  const errorMessage = createErrorMessage(t('downloadError'));

  const { isFetching, refetch } = useQuery(
    [queryKeys.unofficialEnergyCertificate, flerboligbyggId],
    () =>
      ekspertInndata
        ? getUnofficialEnergyCertificateFlerboligbyggWithPrioritizedMeasures(
            flerboligbyggId,
            ekspertInndata?.tiltaksListe
          )
        : getUnofficialEnergyCertificateFlerboligbygg(flerboligbyggId),
    {
      onSuccess: ({ data, filename }) => {
        const blobUrl = URL.createObjectURL(data);

        try {
          downloadFile({
            uri: blobUrl,
            filename
          });
        } catch {
          addSnack(errorMessage, { variant: 'error' });
        } finally {
          URL.revokeObjectURL(blobUrl);
        }
      },
      onError: () => {
        addSnack(errorMessage, { variant: 'error' });
      },
      enabled: false
    }
  );

  return { getCertificate: () => refetch(), isLoading: isFetching };
};
